import { connect } from 'react-redux';

import { getFullName } from '../Person/utils';

import * as buildingSelectors from '../Building/selectors';
import * as communitySelectors from '../Community/selectors';

const mapStateToProps = (state) => state;

export const pmcBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, pmcs }) => {
  const pmcId = match?.params?.pmcId;
  const pmc = pmcId && pmcs[pmcId];
  return pmc?.name ?? '...';
});

export const accessCardBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match }) => {
  const accessCardId = match.params && match.params.id;
  const isCreate = Number.isNaN(Number(accessCardId));
  return isCreate ? 'Create' : 'Update';
});

export const buildingBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, buildings }) => {
  const buildingId = match?.params?.buildingId;
  const building = buildingId && buildings[buildingId];
  return building?.name ?? '...';
});

export const cameraBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, buildings }) => {
  const buildingId = match?.params?.buildingId;
  const building = buildingId && buildings[buildingId];
  const cameraId = match?.params?.cameraId;
  const cameras = cameraId && building?.cameras;
  const camera = cameras?.find(({ id }) => Number(id) === Number(cameraId));
  return camera?.name ?? '...';
});

export const personBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, people, person: currentPerson }) => {
  const personId = match?.params?.personId;
  let person = personId && people[personId];
  if (!person) {
    person = personId && currentPerson;
  }
  return person && person.firstName
    ? `${person.firstName} ${person.lastName}`
    : '...';
});

export const residentBreadcrumbs = connect(
  mapStateToProps,
  null,
)((props) => {
  const { match } = props;
  const buildingId = match?.params?.buildingId;
  const personId = match?.params?.personId;

  const resident = buildingSelectors.getBuildingResidentById(
    props,
    buildingId,
    personId,
  );

  return resident?.id ? getFullName(resident) : '...';
});

export const unitBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, units }) => {
  const isCreateInUnit = match.path.includes('create-in-unit');
  const unitId = match.params && match.params.unitId;
  const unit = unitId && units[unitId];
  if (isCreateInUnit && unit && unit.name) return `Create in '${unit.name}'`;
  return unit && unit.name ? unit.name : '...';
});

export const accessPointBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, accessPoints }) => {
  const accessPointId = match?.params?.accessPointId;
  const accessPoint =
    accessPointId &&
    accessPoints.find(({ id }) => Number(id) === Number(accessPointId));
  return accessPoint?.name ?? '...';
});

export const doorBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, doors }) => {
  const doorId = match?.params?.doorId;
  const door =
    doorId && doors.find((door) => Number(door.id) === Number(doorId));
  return door?.name ?? '...';
});

export const externalAccountBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, externalAccounts }) => {
  const accountId = match?.params?.accountId;
  const account = externalAccounts?.account ?? {};
  const { name, id } = account;
  return name && Number(id) === Number(accountId) ? name : '...';
});

export const serviceRequestBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ serviceRequests }) => {
  const serviceRequest = serviceRequests?.srData ?? {};
  const { categoryName, carsonServiceRequestId, yardiId } = serviceRequest;
  const srId = yardiId || carsonServiceRequestId;
  const title = [srId, categoryName].filter(Boolean).join(' - ');
  return title || '...';
});

export const visitorBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, visitors }) => {
  const visitorId = match?.params?.visitorId;
  const visitor = visitorId && visitors[visitorId]?.person;
  return visitor ? `${visitor.firstName} ${visitor.lastName}` : '...';
});

export const visitorUpdateBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, visitors }) => {
  const personId = match?.params?.personId;
  if (!personId) return '...';
  const visitor =
    visitors?.results?.find(
      (visitor) => Number(visitor.id) === Number(personId),
    ) || visitors?.[personId];
  const { firstName, lastName } = visitor?.person || {};
  return visitor?.person ? `${firstName} ${lastName}` : '...';
});

export const deliveryTypesBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, deliveryType }) => {
  const deliveryTypeId = match?.params?.id;
  if (deliveryTypeId === 'create') return 'Create';
  const name = deliveryType?.name;
  return name ? `${name}` : '...';
});

export const personSearchBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ admins }) => {
  const person = admins.results && admins.results[0];
  return person ? `${person.firstName} ${person.lastName}` : '...';
});

export const amenityBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, amenity }) => {
  const amenityId = match?.params?.id;
  if (amenityId === 'create') return 'add';
  const amenityName = amenity?.details?.[amenityId]?.data?.name;
  return amenityName ?? '...';
});

export const amenityReservationBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ match, amenity }) => {
  const reservationId = match?.params?.id;
  if (reservationId === 'create') return 'add';
  const reservationName = amenity?.amenityReservation?.amenity?.name;
  return reservationName ?? '...';
});

export const communityBreadcrumbs = connect(
  mapStateToProps,
  null,
)((state) => {
  const communityId = communitySelectors.getCommunityId(state);
  const { name } = communitySelectors.getCommunityById(state, communityId);
  return name ?? '...';
});

export const eventBreadcrumbs = connect(
  mapStateToProps,
  null,
)(({ events }) => {
  const { name } = events.event;
  return name ?? '...';
});
